import { View, Text } from "react-native";
import { ThumbsUp } from "lucide-react-native";
import { EMBER } from "../../../onboarding/theme";
import { GLASS_CARD_STYLE } from "@louise/moon-ui/theme/tokens";
import { ListRowSkeleton } from "@louise/moon-ui";

export default function WhatToDoCard() {
  return (
    <View style={{ ...GLASS_CARD_STYLE, padding: 16 }}>
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          gap: 8,
          marginBottom: 8,
        }}
      >
        <ThumbsUp size={14} color={EMBER.colors.textLight} strokeWidth={1.75} />
        <Text
          className="font-dm-sans"
          style={{
            fontSize: 15,
            fontWeight: "600",
            color: EMBER.colors.text,
          }}
        >
          What to do
        </Text>
      </View>
      <ListRowSkeleton showSubtitle />
      <ListRowSkeleton showSubtitle />
      <ListRowSkeleton showSubtitle />
    </View>
  );
}
